import { functions } from "@/services/firebase";
import { SACBaseService } from "vue-chess-shared/services/SACBaseService";

const handleSACAPICall = functions.httpsCallable("sac-handleSACAPICall");

class SACFrontendService extends SACBaseService {
  serializer = (data) =>
    localStorage.setItem("teacherAuth", JSON.stringify(data));
  deserializer = () => {
    try {
      const data = localStorage.getItem("teacherAuth");
      return JSON.parse(data);
    } catch (error) {
      console.error(error);
    }
  };

  async request(_, options) {
    const response = await handleSACAPICall(options);
    return response.data;
  }
}

export default new SACFrontendService();
